module.exports = __webpack_public_path__ + "static/media/md-cellular.eb6f210e.svg";